<div class="sat-dialog-shell">
  <div class="sat-dialog-header">
    <h2 mat-dialog-title class="sat-dialog-title">{{ title }}</h2>
    <button type="button" class="sat-dialog-close" (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="sat-dialog-body">
    <form [formGroup]="formGroup" class="sat-dialog-form">
      <div class="sat-form-field">
        <label class="sat-form-label" for="attributeTypeName">Attribute Name *</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
          <input
            id="attributeTypeName"
            matInput
            formControlName="AttributeTypeName"
            placeholder="e.g., Organic Section, Drive-Through Pharmacy"
            required />
        </mat-form-field>
        <div
          class="sat-inline-error"
          *ngIf="formGroup.get('AttributeTypeName')?.hasError('required') && formGroup.get('AttributeTypeName')?.touched">
          Attribute name is required
        </div>
        <div class="sat-inline-error" *ngIf="formGroup.get('AttributeTypeName')?.hasError('apiError')">
          {{ formGroup.get('AttributeTypeName')?.getError('apiError') }}
        </div>
      </div>

      <div class="sat-form-row">
        <div class="sat-form-field">
          <label class="sat-form-label" for="attributeCategory">Category *</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
            <mat-select id="attributeCategory" formControlName="CategoryId" required placeholder="Select category...">
              <mat-option disabled value="">Select category...</mat-option>
              <mat-option *ngFor="let category of data.categories" [value]="category.id">
                {{ category.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="sat-inline-error"
            *ngIf="formGroup.get('CategoryId')?.hasError('required') && formGroup.get('CategoryId')?.touched">
            Category is required
          </div>
          <div class="sat-inline-error" *ngIf="formGroup.get('CategoryId')?.hasError('apiError')">
            {{ formGroup.get('CategoryId')?.getError('apiError') }}
          </div>
        </div>

        <div class="sat-form-field">
          <label class="sat-form-label" for="valueType">Value Type *</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
            <mat-select id="valueType" formControlName="ValueType" required placeholder="Select value type...">
              <mat-option disabled value="">Select value type...</mat-option>
              <mat-option *ngFor="let type of valueTypes" [value]="type">
                {{ valueTypeLabels[type] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="sat-inline-error"
            *ngIf="formGroup.get('ValueType')?.hasError('required') && formGroup.get('ValueType')?.touched">
            Value type is required
          </div>
          <div class="sat-inline-error" *ngIf="formGroup.get('ValueType')?.hasError('apiError')">
            {{ formGroup.get('ValueType')?.getError('apiError') }}
          </div>
        </div>
      </div>

      <div class="sat-form-field" *ngIf="showSourceField">
        <label class="sat-form-label" for="sourceField">Source Field (optional)</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
          <mat-select id="sourceField" formControlName="ValueSourceField" placeholder="Select source field...">
            <mat-option [value]="''">None</mat-option>
            <mat-option *ngFor="let field of sourceFieldOptions" [value]="field">
              {{ field }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p class="sat-field-hint">If specified, values will be auto-populated during store profile import.</p>
        <div
          class="sat-inline-error"
          *ngIf="formGroup.get('ValueSourceField')?.hasError('allowedSourceField') && formGroup.get('ValueSourceField')?.touched">
          Source field must be one of: City, State, Country, Division, Banner.
        </div>
        <div class="sat-inline-error" *ngIf="formGroup.get('ValueSourceField')?.hasError('apiError')">
          {{ formGroup.get('ValueSourceField')?.getError('apiError') }}
        </div>
      </div>

      <mat-checkbox formControlName="FilterEnabled" class="sat-filter-checkbox" [class.sat-filter-checkbox--disabled]="isFilterCheckboxDisabled">
        Enable as filter in Version Search &amp; Offer Association
      </mat-checkbox>
      <div class="sat-inline-error" *ngIf="formGroup.get('FilterEnabled')?.hasError('apiError')">
        {{ formGroup.get('FilterEnabled')?.getError('apiError') }}
      </div>

      <div *ngIf="showAllowedValuesEditor" class="sat-allowed-values-panel">
        <label class="sat-form-label">Define Allowed Values</label>
        <div class="sat-allowed-values-chips" *ngIf="allowedValues.length">
          <span class="sat-value-tag" *ngFor="let value of allowedValues">
            {{ value }}
            <button type="button" class="sat-value-tag__remove" (click)="removeValue(value)" aria-label="Remove value">&times;</button>
          </span>
        </div>
        <div class="sat-allowed-values-input">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript sat-value-input-field">
            <input
              matInput
              [(ngModel)]="newValueInput"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Type a value and press Enter..."
              (keydown)="onValueInputKeydown($event)" />
          </mat-form-field>
          <button type="button" class="sat-btn sat-btn--outline sat-btn--compact" (click)="addValue()">
            Add
          </button>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="sat-dialog-footer">
    <button type="button" class="sat-btn sat-btn--outline" (click)="onCancel()" [disabled]="isSaving">
      Cancel
    </button>
    <button type="button" class="sat-btn sat-btn--primary" (click)="onSave()" [disabled]="isSaving">
      {{ saveButtonLabel }}
    </button>
  </mat-dialog-actions>
</div>
